import { Underline as UnderlineToExtend } from '@tiptap/extension-underline';

export const Underline = UnderlineToExtend.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            },
            style: {
                default: null
            }
        }
    }
})
